/**
 * 俄语
 * 当前仅支持 Yandex登录 2024/11/18
 */
import {ru as yandexLogin} from './gogole/ru';
import {ru as privatisation} from './privatisation/ru';

const defaultRu ={
    'header_title': 'Платформа разработчиков',
    'home_title': 'Платформа разработчиков Qingping',
    'do_yourself': 'Создайте правила самостоятельно',
    'deep_customize': 'Позвольте продуктам Qingping идеально интегрироваться с вашей платформой.',
    'start': 'Предпросмотр',
    'login': 'Войти',
    'checkout_docs': 'Открыть документацию',
    'cancel': 'Отмена',
    'consent': 'Подтвердить',
    'consent_title': 'Авторизовать для получения следующей информации:',

    'welcome': 'Войти',
    'phone': 'Номер телефона',
    'phone_login': 'Номер телефона',
    'email_login': 'Электронная почта',
    'password': 'Пароль',
    'code': 'Код',
    'send': 'Отправить',
    'via_email': 'Войти по почте',
    'via_password': 'Войти по паролю',
    'via_verify': 'Войти с помощью кода',
    'email': 'Адрес электронной почты',
    'desc_1': 'Войдите с аккаунтом Qingping. Если у вас нет аккаунта, зарегистрируйтесь через ',
    'desc_1_1': 'приложение Qingping IoT',
    'desc_2': ' или ',
    'desc_3': 'приложение Qingping+',
    'desc_4': '. ',
    'input_account': 'Введите ваш аккаунт',
    'input_correct': 'Введите корректный ',
    'email_txt': 'формат электронной почты',
    'phone_txt': 'номер телефона',

    'docs': 'Документация',
    'get_stared': 'Начать',
    'guideline': 'Руководство',
    'qingping_air_monitor': 'Воздухомер Qingping',
    'dany': 'Воздухомер Qingping Lite',
    'RH_WIFI': 'Барометр Qingping температуры и влажности (Wi-Fi)',
    'RH_NB_IOT': 'Барометр Qingping температуры и влажности (NB-IoT)',
    'RH_LoRa': 'Барометр Qingping температуры и влажности (LoRa)',
    'RH_PRO_WIFI': 'Монитор температуры и влажности Qingping Pro (Wi-Fi)',
    'RH_PRO_NB_IOT': 'Монитор температуры и влажности Qingping Pro (NB-IoT)',
    'access': 'Доступ',
    'instruction': 'Инструкции',
    'OAuth': 'OAuth 2.0',
    'open_interface': 'Открытый интерфейс',
    'data_push': 'Передача данных',
    'SDK_instruction': 'Инструкции по SDK',
    'private_cloud': 'Частное облако',
    'private_deployment': 'Частное развертывание',
    'SDK': 'SDK',
    'RH_LoRa_WAN': 'Протокол Qingping LoRaWAN',

    'my': 'Мое',
    'access_managemennt': 'Управление доступом',
    'apply_access': 'Запросить доступ',
    'access_information': 'Информация о доступе',
    'apply_app_key_and_app_secret': 'Запросить ключ приложения и секрет приложения',
    'data_push_setting': 'Настройка передачи данных',
    'webhook_setting': 'Настройка Webhook',
    'MQTT_setting': 'Настройка MQTT',
    'device_data_webhook': 'Webhook данных устройства',
    'address_optional': 'Адрес (необязательно)',
    'device_time_webhook': 'Webhook времени устройства',
    'edit': 'Редактировать',
    'others': 'Другое',
    'feedback': 'Обратная связь',
    'issueTip': 'Пожалуйста, отправьте ваш вопрос в разделе "Ещё > Свяжитесь с нами" приложения Qingping+ или Qingping IoT. Спасибо.',
    'help': 'Чем мы можем вам помочь?',
    'contact': 'Укажите ваш номер телефона, WeChat или email, чтобы мы могли с вами связаться.',
    'feedback_suggestion': 'Обратная связь',
    'logout': 'Выйти',
    'apply': 'Применить',
    'save': 'Сохранить',
    'clear': 'Очистить',
    'before': 'До',
    'data': 'Данные',
    'event': 'Событие',
    'test': 'Тест',
    'confirm': 'Подтвердить',
    'add': 'Добавить поле',

    "account_or_password_error": "Неверный логин или пароль.",
    "captcha_limit_exceeded": "Превышено количество попыток.",
    "username_or_password_limit_exceeded": "Превышено количество попыток входа.",
    "user_type_error": "Неверный тип пользователя.",
    
    login_failed_pwd_error: 'Неверный пароль, пожалуйста, введите снова или используйте вход с кодом подтверждения.',
    login_failed_account_not_exist: 'Аккаунт не существует.',
    verification_to_many: 'Слишком много попыток, попробуйте через 10 минут.',
    verification_code_error: 'Неверный код, пожалуйста, проверьте и попробуйте снова.',

    next: '下一步',
   
}

export default {
    ...defaultRu,
    ...yandexLogin,
    ...privatisation
}